import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { AuthService } from './services/auth.service';

// Modulos
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { NotifierModule } from 'angular-notifier';

// Components
import { AppComponent } from './app.component';
import { environment } from '../environments/environment.prod';
import { LoginComponent } from './pages/login/login.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { PortalComponent } from './pages/portal/portal.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { ModalBusquedaComponent } from './components/modal-busqueda/modal-busqueda.component';
import { NuevoSistemaComponent } from './components/nuevo-sistema/nuevo-sistema.component';
import { CambiosFuncionalidadesComponent } from './components/cambios-funcionalidades/cambios-funcionalidades.component';
import { CorreccionFuncionalidadesComponent } from './components/correccion-funcionalidades/correccion-funcionalidades.component';
import { LoadingComponent } from './components/shared/loading/loading.component';
import { MisIniciativasComponent } from './pages/mis-iniciativas/mis-iniciativas.component';
import { ModalIniciativaComponent } from './components/modal-iniciativa/modal-iniciativa.component';
import { AdministracionComponent } from './pages/administracion/administracion.component';
import { TablaIniciativasComponent } from './components/administracion/tabla-iniciativas/tabla-iniciativas.component';
import { ControlUsuariosComponent } from './components/administracion/control-usuarios/control-usuarios.component';
import { LiderProyectoComponent } from './pages/lider-proyecto/lider-proyecto.component';
import { ModalCalendarioComponent } from './components/modal-calendario/modal-calendario.component';
import { AddUsuariosComponent } from './pages/usuarios/add-usuarios/add-usuarios.component';
import { SharedModule } from  './components/modules/shared/shared.module';
import {MatInputModule} from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatTableModule} from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ModalUsuarioComponent } from './components/modal-usuario/modal-usuario.component';
import { ModalUsuarioEdicionComponent } from './components/modal-usuario-edicion/modal-usuario-edicion.component';
import { ConfirmComponent } from './components/shared/confirm/confirm.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CosteoProcesoComponent } from './components/costeo-proceso/costeo-proceso.component';
import { ModalProcedimientoComponent } from './components/modal-procedimiento-asis/modal-procedimiento.component';
import { ModalCosteoConsultaComponent } from './components/modal-costeo-consulta/modal-costeo-consulta.component';
import { ConfirmListadoIniciativasComponent } from './components/shared/confirm-listado-iniciativas/confirm-listado-iniciativas.component';
import { ModalPriorizacionComponent } from './components/modal-priorizacion/modal-priorizacion.component';
import { ModalConsultaIniciativaComponent } from './components/modal-consulta-iniciativa/modal-consulta-iniciativa.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatStepperModule} from '@angular/material/stepper';
import { SeleccionRolComponent } from './pages/seleccion-rol/seleccion-rol.component';
import {MatTabsModule} from '@angular/material/tabs';
import { ConfirmListadoIniciativasAdminComponent } from './components/shared/confirm-listado-iniciativas-admin/confirm-listado-iniciativas-admin.component';
import {MatSelectModule} from '@angular/material/select';
import { PeriodosEnvioComponent } from './components/administracion/periodos-envio/periodos-envio.component';
import { MotivosIniciativaComponent } from './components/administracion/motivos-iniciativa/motivos-iniciativa.component';
import {MatListModule} from '@angular/material/list';
import { EstructuraComponent } from './components/administracion/estructura/estructura.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import {MatCardModule} from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';
import { PriorizacionIniciativasComponent } from './components/administracion/priorizacion-iniciativas/priorizacion-iniciativas.component';
import { ConfirmListadoTablaIniciativasComponent } from './components/shared/confirm-listado-tabla-iniciativas/confirm-listado-tabla-iniciativas.component';
import { EquipoTrabajoComponent } from './components/equipo-trabajo/equipo-trabajo.component';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import {MatBadgeModule} from '@angular/material/badge';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { EnlacesComponent } from './components/administracion/enlaces/enlaces.component';
import { AplicacionesComponent } from './components/administracion/aplicaciones/aplicaciones.component';
import { FormatosApoyoComponent } from './components/administracion/formatos-apoyo/formatos.component';
import { ReportesComponent } from './components/administracion/reportes/reportes.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';
import { DialogCambioTipoIniciativaComponent } from './components/dialog-cambio-tipo-iniciativa/dialog-cambio-tipo-iniciativa.component';
import { DialogAsignaEnlaceComponent } from './components/dialog-asigna-enlace/dialog-asigna-enlace.component';
import { CalendarioVisualComponent } from './components/administracion/calendario-visual/calendario-visual.component';
import { ConfirmDialogComponent } from './components/confirmacion/confirm.component'; // Asegúrate de importar tu componente

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavbarComponent,
    PortalComponent,
    FooterComponent,
    ModalBusquedaComponent,
    NuevoSistemaComponent,
    CambiosFuncionalidadesComponent,
    CorreccionFuncionalidadesComponent,
    LoadingComponent,
    MisIniciativasComponent,
    ModalIniciativaComponent,
    AdministracionComponent,
    TablaIniciativasComponent,
    ControlUsuariosComponent,
    LiderProyectoComponent,
    ModalCalendarioComponent,
    AddUsuariosComponent,
    ModalUsuarioComponent,
    ModalUsuarioEdicionComponent,
    ConfirmComponent,
    CosteoProcesoComponent,
    ModalProcedimientoComponent,
    ModalCosteoConsultaComponent,
    ConfirmListadoIniciativasComponent,
    ModalPriorizacionComponent,
    ModalConsultaIniciativaComponent,
    SeleccionRolComponent,
    ConfirmListadoIniciativasAdminComponent,
    PeriodosEnvioComponent,
    MotivosIniciativaComponent,
    EstructuraComponent,
    PriorizacionIniciativasComponent,
    ConfirmListadoTablaIniciativasComponent,
    EquipoTrabajoComponent,
    EnlacesComponent,
    AplicacionesComponent,
    FormatosApoyoComponent,
    ReportesComponent,
    ConfirmacionComponent,
    ConfirmDialogComponent,
    DialogCambioTipoIniciativaComponent,
    DialogAsignaEnlaceComponent,
    CalendarioVisualComponent
    ],
  
  entryComponents:[ConfirmComponent],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SharedModule,
    MatInputModule,
    MatStepperModule,
    DragDropModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatGridListModule,
    MatTabsModule,
    MatListModule,
    MatIconModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDialogModule,
    AngularFireAuthModule,
    FormsModule,
    MatBadgeModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatBottomSheetModule,
    MatCardModule,
    MatDatepickerModule,
    MatButtonModule,
    MatNativeDateModule,
    MatMenuModule,
    AngularFireModule.initializeApp(environment.firebase),
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'middle',
          distance: 12
        },
        vertical: {
          position: 'bottom',
          distance: 12,
          gap: 10
        }
      }
    }),
    NgbModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
